import {
  useGetDnPurchaseHistoryMutation,
  useGetPurchaseHistoryMutation,
} from '../../../../../services/cellcast.v3'
import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {stopLoading, startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GetPurchaseHistory} from './BillingSlice/BillingSlice'
import {useLazyGetDedicatedNumberTransactionsQuery} from '../../../../../services/cellcast'

type params = {
  id: string
  page: {}
}

export function usePurchaseHistory() {
  const dispatch = useDispatch()
  const currentUser = GetCurrentData()

  const purchase_history = useSelector((state: any) => state?.paymentGateway?.userPurchase)

  const [getPurchaseHistory, {data: trxHistory}] = useGetPurchaseHistoryMutation()

  const [fetchHistory, {data: dnPurchaseHistory, isLoading, isFetching}] =
    useLazyGetDedicatedNumberTransactionsQuery()
  const [getDnPurchaseHistory, {data: dnRegionPurchaseHistory, isLoading: isLoadingDN}] =
    useGetDnPurchaseHistoryMutation()

  const fetchPurchaseHistory = (params?: params) => {
    if (currentUser?.region === defaultRegion) {
      dispatch(GetPurchaseHistory(params))
    } else {
      dispatch(startLoadding())
      getPurchaseHistory({
        action: 'find_purchase_history',
        data: {
          ...params?.page,
          limit: 10,
          id: params?.id,
        },
      })
      dispatch(stopLoading())
    }
  }

  const fetchDNPurchaseHistory = (params?: any) => {
    if (currentUser?.region === defaultRegion) {
      fetchHistory(params)
    } else {
      dispatch(startLoadding())
      getDnPurchaseHistory({
        action: 'find_dn_purchase_history',
        data: {
          ...params,
          limit: 10,
          id: params?.id,
        },
      })
      dispatch(stopLoading())
    }
  }

  return {
    fetchPurchaseHistory,
    purchaseHistory: currentUser?.region === defaultRegion ? purchase_history : trxHistory?.data,
    fetchHistory: fetchDNPurchaseHistory,
    dnPurchaseHistory:
      currentUser?.region === defaultRegion ? dnPurchaseHistory : dnRegionPurchaseHistory,
    isLoading: currentUser?.region === defaultRegion ? isLoading : isLoadingDN,
    isFetching: currentUser?.region === defaultRegion ? isFetching : false,
  }
}
